import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

export interface ISetProjectControlledPermissionsParams {
  ids: string[];
  nestedProjectsPermissionsIncluded?: boolean;
}

export class SetProjectControlledPermissionsRequest
    extends Request<ISetProjectControlledPermissionsParams, IEmptyResult> {
  constructor(params: ISetProjectControlledPermissionsParams) {
    super('setProjectControlledPermissions', params);
  }
}
